export default __webpack_public_path__ + "static/media/mockup.dfbc0ccb.svg";